import { OnInit, Component } from '@angular/core';
import { AuthenticationService, TokenPayload, TestData} from '../services/authentication.service';
import { Router } from '@angular/router';
import { NgForm, FormBuilder, FormGroup, Validators } from '@angular/forms';
import {MediaMatcher} from '@angular/cdk/layout';
import {ChangeDetectorRef} from '@angular/core';
import { TestTakerService } from '../services/test_taker.service';
import Swal from 'sweetalert2';

@Component({
  templateUrl: './createTestTaker.component.html',
  styleUrls: [ './createTestTaker.component.scss' ]
})
export class CreateTestTakerComponent implements OnInit {
  credentials: TokenPayload = {
    id: '',
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    // confirmpassword: '',
    phone: '',
    type: ''
  };

  registerForm: FormGroup;
  submitted = false;

  result: string[];
  userAdmin: boolean;
  userSuperAdmin: boolean;
  userTestScheduler: boolean;
  userTestTaker: boolean;
  display: boolean;
  overall: boolean;
  questionset: boolean;
  scheduletest: boolean;
  evaluate: boolean;
  test: TestData = {
    id: '',
    FirstName: '',
    LastName: '',
    Email: '',
    Phone: '',
    Type: ''
  };
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  links = ['Super Admin', 'Admin', 'Test Scheduler', 'Test Taker'];
  email;
  user;
  fname;
  lname;
  columns: string[];

    constructor(private auth: AuthenticationService, private router: Router, private formBuilder: FormBuilder,
                private testtakerservice: TestTakerService, changeDetectorRef: ChangeDetectorRef, media: MediaMatcher) {

      this.simpletest();
      this.mobileQuery = media.matchMedia('(max-width: 600px)');
      this._mobileQueryListener = () => changeDetectorRef.detectChanges();
      this.mobileQuery.addListener(this._mobileQueryListener);
                }

    ngOnInit() {
      this.registerForm = this.formBuilder.group({
          first_name: ['', Validators.required],
          last_name: ['', Validators.required],
          email: ['', [Validators.required, Validators.email]],
          password: ['', [Validators.required, Validators.minLength(5)]],
          // confirmpassword: ['', [Validators.required, Validators.minLength(10)]],
          phone: ['', [Validators.required, Validators.minLength(9) ]]
      });
  }

  get f() {
    return this.registerForm.controls;
  }
  simpletest() {
    this.testtakerservice.test_taker(this.test).subscribe(
    (data) => {

     this.result = data.results;
     this.user = sessionStorage.getItem('user');
     this.fname = sessionStorage.getItem('fname');

     this.lname = sessionStorage.getItem('lname');


     if (this.user === '2') {

      this.userAdmin = false;
      this.userSuperAdmin = false;
      this.userTestScheduler = true;
      this.userTestTaker = true;

      this.display = true;
      this.questionset = true;
      this.scheduletest = true;
      this.overall = true;
      this.evaluate = true;
     } else if ( this.user === '1') {
      this.userAdmin = true;
      this.userSuperAdmin = true;
      this.userTestScheduler = true;
      this.userTestTaker = true;
      this.display = true;
      this.questionset = true;
      this.scheduletest = true;
      this.overall = true;
      this.evaluate = true;
     } else if ( this.user === '3') {
      this.userAdmin = false;
      this.userSuperAdmin = false;
      this.userTestScheduler = false;
      this.userTestTaker = true;
      this.questionset = true;
      this.scheduletest = true;
      this.overall = true;
      this.evaluate = true;
      this.display = true;
     } else if ( this.user === '4') {
      this.userAdmin = false;
      this.userSuperAdmin = false;
      this.userTestScheduler = false;
      this.userTestTaker = false;
      this.display = false;
      this.questionset = false;
      this.scheduletest = false;
      this.overall = false;
      this.evaluate = false;
      return this.result;
     }
    },
    err => {
      console.error(err);
    }
  );
}
  createTestTaker() {
    this.submitted = true;

    if (this.registerForm.invalid) {

      return;
    } else {
      this.testtakerservice.createTestTaker(this.credentials).subscribe(
        (data) => {
          if (data.code === 200) {
            Swal.fire({
              title: 'Success',
              text: data.success,
              icon: 'success',
              showCancelButton: false,
              confirmButtonText: 'OK'
            }).then((result) => {
              if (result.isConfirmed) {
                this.router.navigateByUrl('/test_taker');
              }
            })
          } else {
          Swal.fire({
            title: 'Alert',
            text: data.failed,
            icon: 'warning',
            showCancelButton: false,
            confirmButtonText: 'OK'
          }).then((result) => {
            if (result.isConfirmed) {
              // this.router.navigateByUrl('/test_scheduler');
            }
          })
        }

        },
        err => {
          console.error(err);
        }
      );
      }
    }

    Oncancel() {
      this.router.navigateByUrl('/test_taker');
    }
 }
